import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { UpgraderService } from '../upgrader.service';
import { FormsModule } from '@angular/forms';
import { InventoryTemplateComponent } from '../../../core/components/inventory-template/inventory-template.component';
import { SessionService } from '@core/services/session.service';

@Component({
  selector: 'app-upgrader-skins-selection',
  templateUrl: './upgrader-skins-selection.component.html',
  styleUrls: ['./upgrader-skins-selection.component.scss'],
  standalone: true,
  imports: [FormsModule, InventoryTemplateComponent],
  host: {
    class: 'box-black-third rounded-6',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpgraderSkinsSelectionComponent {
  public upgraderService = inject(UpgraderService);
  public sessionService = inject(SessionService);
}
